import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import GEO from './geo';
import GMaps from './gmaps';

$(document).ready(() => {
  $('.header__hamburger').on('click', () => {
    $('.header__hamburger .ham').toggleClass('active');
    $('#nav-main').toggleClass('active');
  });
  $('.bigger').on('click', () => {
    //  let fontSize= size + 1
    //   $()
  });

  const geo = new GEO();
  $('#localization__button').on('click', () => {
    geo.readGPS();
    geo.saveInfo();
    let limit = 10;
    let interval = setInterval(() => {
      geo.saveInfo();
      if (this.lat > 0 && this.lng > 0) {
        clearInterval(interval);
      }
      if (limit-- === 0) {
        clearInterval(interval);
      }
    }, 50);
  });

  if ($('body').hasClass('single-dps')) {
    const gmap = new GMaps($('.single-dps__gmap'));
  }

  $('#voivodeship').on('input', () => {
    $('#voivodeship').parents('form').submit();
  })
});



// Your scripts here
